<div class="modal fade" id="chatAI" aria-hidden="true" aria-labelledby="chatAILabel" tabindex="-1">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
            <div class="modal-header title">
                <h5 class="modal-title text-white" id="chatAILabel"><i class="fa fa-robot"></i> TAI</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-alert #alert></app-alert>
                <div class="container-fluid">
                    <div class="incoming_msg">
                        <div class="incoming_msg_img"> <img src="assets/chaticonV3.png" alt="sunil"> </div>
                        <div class="received_msg">
                            <div class="received_withd_msg">
                                <p>Como posso ajudar?</p>
                                <span class="time_date"> TAI - {{ curDate | date: 'dd/MM/yyyy
                                    HH:mm:ss'}}</span>
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let item of data.Messages">
                        <ng-template [ngIf]="item.UserMessage">
                            <div class="outgoing_msg">
                                <div class="sent_msg">
                                    <div class="is-gray-lighter">
                                        <p>{{item.Text}}</p>
                                        <ul class="nav flex-column">
                                            <li class="nav-item" *ngFor="let citation of item.Files">
                                                <a class="nav-link active" aria-current="page"
                                                    href="#">{{citation.Filepath}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <span class="time_date"> {{item.User}} - {{item.Date | date: 'dd/MM/yyyy
                                        HH:mm:ss'}}</span>
                                </div>
                            </div>
                        </ng-template>

                        <ng-template [ngIf]="!item.UserMessage">
                            <div class="incoming_msg">
                                <div class="incoming_msg_img"> <img src="assets/chaticonV3.png" alt="sunil"> </div>
                                <div class="received_msg">
                                    <div class="received_withd_msg">
                                        <div class="is-gray-lighter">                                            
                                            <ul class="nav flex-column">
                                                <li class="nav-item" *ngFor="let citation of item.Files">
                                                    <a class="nav-link active" aria-current="page"
                                                        href="#">{{citation.Filepath}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <span class="time_date"> {{item.User}} - {{item.Date | date: 'dd/MM/yyyy
                                            HH:mm:ss'}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="modal-footer">                
                <div class="input-group" *ngIf="loading">
                    <!-- <div class="incoming_msg_img">  </div> -->
                    <img src="assets/chaticonV3.png" style="width: 2%;" alt="sunil">

                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <div class="input-group mb-3 mt--2">
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="2" (keydown.enter)="submit()"
                        [(ngModel)]="text" [readonly]="loading"></textarea>
                    <div class="input-group-append" (click)="submit()">
                        <span class="input-group-text" id="basic-addon2">
                            <i class="material-icons">send</i>
                        </span>
                    </div>
                </div>
                <p class="disclaimer text-dark">
                    As informações desta ferramenta são apenas orientativas e devem ser confirmadas pelos nossos
                    especialistas.
                    A <strong>TEADIT®</strong> não garante a aplicação dessas informações sem validação oficial de nossa equipe técnica.
                </p>
            </div>
        </div>
    </div>
</div>




<!--
<div class="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="chatAI"
    aria-labelledby="chatAILabel">
    <div class="offcanvas-header title">
        <h5 class="offcanvas-title text-white" id="chatAILabel"><i class="fa fa-robot"></i> TAI</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">        
        <app-alert #alert></app-alert>
        <div class="container">
            <div class="incoming_msg">
                <div class="incoming_msg_img"> <img src="assets/chaticonV3.png" alt="sunil"> </div>
                <div class="received_msg">
                    <div class="received_withd_msg">
                        <p>Como posso ajudar?</p>
                        <span class="time_date"> TAI - {{ curDate | date: 'dd/MM/yyyy
                            HH:mm:ss'}}</span>
                    </div>
                </div>
            </div>

            <div *ngFor="let item of data.Messages">
                <ng-template [ngIf]="item.UserMessage">
                    <div class="outgoing_msg">
                        <div class="sent_msg">
                            <div class="is-gray-lighter">
                                <p>{{item.Text}}</p>
                                <ul class="nav flex-column">
                                    <li class="nav-item" *ngFor="let citation of item.Files">
                                        <a class="nav-link active" aria-current="page"
                                            href="#">{{citation.Filepath}}</a>
                                    </li>
                                </ul>
                            </div>
                            <span class="time_date"> {{item.User}} - {{item.Date | date: 'dd/MM/yyyy
                                HH:mm:ss'}}</span>
                        </div>
                    </div>
                </ng-template>

                <ng-template [ngIf]="!item.UserMessage">
                    <div class="incoming_msg">
                        <div class="incoming_msg_img"> <img src="assets/chaticonV3.png" alt="sunil"> </div>
                        <div class="received_msg">
                            <div class="received_withd_msg">
                                <div class="is-gray-lighter">
                                    <markdown clipboard>{{ item.Text }}</markdown>
                                    <ul class="nav flex-column">
                                        <li class="nav-item" *ngFor="let citation of item.Files">
                                            <a class="nav-link active" aria-current="page"
                                                href="#">{{citation.Filepath}}</a>
                                        </li>
                                    </ul>
                                </div>
                                <span class="time_date"> {{item.User}} - {{item.Date | date: 'dd/MM/yyyy
                                    HH:mm:ss'}}</span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="offcanvas-footer p-3 bg-light">
        <div class="input-group" *ngIf="loading">            
            <div class="incoming_msg_img"> <img src="assets/chaticonV3.png" alt="sunil"> </div>
            
            <div class="spinner-grow spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div class="spinner-grow spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div class="spinner-grow spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div class="spinner-grow spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="input-group mb-3 mt--2">
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="2" (keydown.enter)="submit()"
                [(ngModel)]="text" [readonly]="loading"></textarea>
            <div class="input-group-append" (click)="submit()">
                <span class="input-group-text" id="basic-addon2">
                    <i class="material-icons">send</i>
                </span>
            </div>
        </div>
        <p class="disclaimer text-dark">
            As informações desta ferramenta são apenas orientativas e devem ser confirmadas pelos nossos especialistas.
            A <strong>TEADIT®</strong> não garante a aplicação dessas informações sem validação oficial de nossa equipe técnica.
        </p>
    </div>
</div>


-->
